/**
 * Which build this is.
 *
 * Substituted at build time from `package.json` — see `vite.config.ts`. The
 * Android project takes the same number, so a phone and a browser talking to
 * the same server can be compared without asking anybody what they installed.
 */
declare const __APP_VERSION__: string;

export const APP_VERSION: string = __APP_VERSION__;

/** `1.2.3` as a number that only ever increases: 1_02_03. Android needs an
 *  integer `versionCode`, and comparing releases needs an ordering that a
 *  string does not give — "1.10.0" sorts before "1.9.0". */
export function versionCode(version: string): number {
  const [major = 0, minor = 0, patch = 0] = version
    .split('.')
    .map((part) => Number.parseInt(part, 10) || 0);
  return major * 10000 + minor * 100 + patch;
}
